import { createContext, useContext } from 'react';
import { Stakeholder } from '../interfaces/interfaces';

export interface IUserContextProps {
    loggedIn: boolean | undefined;
    customerId: string | undefined;
    stakeholder: Stakeholder | undefined;
    ageValid: boolean;
    cprValid: boolean;
    isBornholm: boolean;
    canProceed: boolean;
    age: number | undefined;
    addressInBBR: boolean | undefined;
    isNeedOtherCoverage: boolean;
}

const UserContext = createContext<IUserContextProps>({} as IUserContextProps);
export { UserContext };
export const useUserContext = () => useContext(UserContext);
